import { ResponsibleMedicalRecordRepository } from '../repositories/ResponsibleMedicalRecordRepository'

export function GetResponsibleMedicalRecordForReviewUseCase(
  repository: ResponsibleMedicalRecordRepository
) {
  return async (params: { id: string }) => {
    return await repository.getResponsibleMedicalRecordForReview(params)
  }
}
